import styled from 'styled-components';
import { white, black } from 'styles/colors';
import { maxWidth } from 'styles/media-queries';
import { spacer8, spacer16, spacer12, spacer1 } from 'styles/spacers';
import { fontWeights } from 'styles/variables';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacer16};
`;

export const Title = styled.h2`
  color: ${white};
  font-size: 2.4rem;
  font-weight: ${fontWeights.extra_bold};
`;

export const Caption = styled.p`
  color: ${white};
  font-size: 1.4rem;
  font-weight: ${fontWeights.normal};
`;

export const Row = styled.div`
  display: flex;
  gap: ${spacer12};
  padding-bottom: ${spacer8};
  width: 612px;

  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  ${maxWidth.lg`
    width: 100%;
    flex-direction: row;
    overflow-x: auto;
  `}
`;

export const Card = styled.div<{ selected: boolean }>`
  box-sizing: border-box;
  width: 144px;
  padding: ${spacer8};
  background: ${({ selected }) =>
    selected ? 'rgba(255, 255, 255, 0.14)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 2rem;
  border: 2px solid;
  border-color: ${({ selected }) => (selected ? white : 'transparent')};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacer8};
  cursor: pointer;
  transition: border 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.14);

    button {
      background-color: #141414;
    }
  }

  &:active {
    background: rgba(255, 255, 255, 0.21);

    button {
      background-color: #343434;
    }
  }
`;

export const CardImage = styled.img<{ type: 'voice' | 'music' }>`
  width: 128px;
  height: 128px;
  border-radius: ${({ type }) => (type === 'voice' ? '100%' : '1rem')};
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacer1};
  width: 12.8rem;
`;

export const CardName = styled.div`
  color: ${white};
  font-size: 2rem;
  font-weight: ${fontWeights.extra_bold};
  text-align: start;
  line-height: 110%;
  flex: 1;
  word-break: break-word;
  letter-spacing: 0%;
`;

export const PlayButton = styled.button<{ isPlaying: boolean }>`
  background-color: ${black};
  border: none;
  border-radius: 100%;
  flex: 0 0 auto;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .voice-player-icon {
    width: ${({ isPlaying }) => (isPlaying ? '2rem' : '1.6rem')};
    height: 2rem;
  }
`;

export const Audio = styled.audio`
  display: none;
`;
